/* ==========================================================================
   VETMA — En-tête
   Compteur panier, panneaux recherche et compte, ouverture du tiroir.
   ========================================================================== */

/* --------------------------------------------------------------------------
   Compteur du panier
   Le nombre suit les ajouts faits ailleurs sur la page, y compris
   le Vetmeter offert ajouté automatiquement.
   -------------------------------------------------------------------------- */
(function () {
  var el = document.querySelector('[data-cart-count]');
  if (!el) return;

  function set(n) {
    el.textContent = n;
    el.classList.toggle('is-empty', !n);
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { set(c.item_count); })
      .catch(function () {});
  }

  ['pageshow', 'focus'].forEach(function (ev) {
    window.addEventListener(ev, refresh);
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh();
  });

  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build',
   'switch:cart:afteradditem'].forEach(function (ev) {
    document.addEventListener(ev, refresh);
  });

  refresh();
})();

/* --------------------------------------------------------------------------
   Panneaux centrés : recherche et compte
   -------------------------------------------------------------------------- */
(function () {
  var searchPanel = document.querySelector('[data-search-panel]');
  var accountPanel = document.querySelector('[data-account-panel]');
  var open = null;

  /* La barre de défilement disparaît avec le panneau ouvert : on
     compense sa largeur pour que la page ne saute pas latéralement. */
  function lockScroll(on) {
    if (on) {
      var gap = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      if (gap > 0) document.body.style.paddingRight = gap + 'px';
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
  }

  function show(panel) {
    if (!panel || open === panel) return;
    if (open) hide();

    panel.hidden = false;
    /* Un souffle avant d'ajouter la classe, sinon la transition
       ne part pas depuis l'état masqué. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
    });

    open = panel;
    lockScroll(true);

    var field = panel.querySelector('[data-search-input]');
    if (field) setTimeout(function () { field.focus(); }, 120);
  }

  function hide() {
    if (!open) return;
    var panel = open;
    open = null;
    lockScroll(false);
    panel.classList.remove('is-open');

    /* On attend la fin du fondu avant de retirer des flux. */
    setTimeout(function () {
      if (!panel.classList.contains('is-open')) panel.hidden = true;
    }, 240);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    if (t.closest('[data-open-search]')) { e.preventDefault(); show(searchPanel); return; }
    if (t.closest('[data-open-account]')) { e.preventDefault(); show(accountPanel); return; }
    if (t.closest('[data-close-panel]')) { e.preventDefault(); hide(); return; }

    /* Un clic sur le fond sombre referme, un clic dans la boîte non. */
    if (open && t.closest('.v-panel') === open && !t.closest('.v-panel__box')) hide();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && open) hide();
  });

  /* --- Recherche en direct dans le panneau --- */

  if (!searchPanel) return;

  var form = searchPanel.querySelector('[data-search-form]');
  var input = searchPanel.querySelector('[data-search-input]');
  var defaults = searchPanel.querySelector('[data-search-default]');
  var results = searchPanel.querySelector('[data-search-results]');
  if (!input || !results) return;

  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;',
               '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Une URL venue de l'API ne doit pouvoir pointer que vers une
     ressource du site : un "javascript:" dans un href s'executerait
     au clic. On n'accepte donc que les chemins relatifs. */
  function safeUrl(u) {
    var s = String(u || '');
    return /^\/(?!\/)/.test(s) ? s : '#';
  }

  function sized(u) {
    return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=300' : '';
  }

  function showDefaults() {
    results.hidden = true;
    results.innerHTML = '';
    if (defaults) defaults.hidden = false;
  }

  function render(q, products) {
    if (defaults) defaults.hidden = true;
    results.hidden = false;

    if (!products || !products.length) {
      results.innerHTML = '<p class="v-panel__empty">No product for "' + esc(q) + '"</p>';
      return;
    }

    var html = '<p class="v-panel__label">Products</p><div class="v-panel__grid">';

    products.forEach(function (p) {
      var rawImg = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
      /* Les images Shopify sont servies depuis son CDN, en https. */
      var img = /^https:\/\/[\w.-]*shopify(cdn)?\.com\//.test(rawImg) ? rawImg : '';

      /* Shopify renvoie les prix déjà formatés dans la devise du visiteur. */
      var price;
      if (p.available === false) {
        price = '<span class="v-panel__out">Sold out</span>';
      } else if (p.compare_at_price && p.compare_at_price !== p.price) {
        price = '<s>' + esc(p.compare_at_price) + '</s>' +
                '<span class="v-panel__sale">' + esc(p.price) + '</span>';
      } else {
        price = esc(p.price);
      }

      html += '<a class="v-panel__item" href="' + esc(safeUrl(p.url)) + '">' +
                '<span class="v-panel__item-img">' +
                  (img ? '<img src="' + esc(sized(img)) + '" alt="" width="300" height="400" loading="lazy">' : '') +
                '</span>' +
                '<span class="v-panel__item-name">' + esc(p.title) + '</span>' +
                '<span class="v-panel__item-price">' + price + '</span>' +
              '</a>';
    });

    html += '</div>';
    html += '<a class="v-panel__all" href="/search?q=' + encodeURIComponent(q) + '">See all results →</a>';
    results.innerHTML = html;
  }

  var timer, ctrl;

  function query() {
    var q = input.value.trim();
    if (q.length < 2) { showDefaults(); return; }

    if (ctrl && ctrl.abort) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;

    fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=8' +
          '&resources[options][unavailable_products]=last',
          ctrl ? { signal: ctrl.signal } : undefined)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var prods = d && d.resources && d.resources.results && d.resources.results.products;
        render(q, prods || []);
      })
      .catch(function () {});
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    timer = setTimeout(query, 220);
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = input.value.trim();
      if (!q) return;
      window.location.href = '/search?q=' + encodeURIComponent(q);
    });
  }
})();

/* --------------------------------------------------------------------------
   Le logo panier ouvre le tiroir sans changer de page.
   Le lien vers /cart sert de repli si le tiroir n'est pas disponible.
   -------------------------------------------------------------------------- */
document.addEventListener('click', function (e) {
  var trigger = e.target.closest && e.target.closest('[data-open-cart-drawer]');
  if (!trigger) return;

  if (window.Alpine && Alpine.store && Alpine.store('modals')) {
    e.preventDefault();
    Alpine.store('modals').open('cart');
  }
});
